import React, { useEffect, useState } from "react";
import axios from "../../axios/axiosUmbraco";
import { useTranslate } from "../TranslationText";
import ReactOwlCarousel from "react-owl-carousel";

const MediaBaseURL = process.env.REACT_APP_BACKEND_API;
const BaseURL = process.env.REACT_APP_BASE_URL;

export default function SponsersSection({ isHomePage = true, isPartner = false, fetch = process.env.REACT_APP_HOME_PAGE_SPONSERS_POST_ID, title = 'web.partners' }) {
    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';

    const [sponsers, setSponsers] = useState([{
        name: "",
        image: '',
        link: '',
        title: "",
    }]);
    const [total, setTotal] = useState(0);
    const { translate } = useTranslate();



    function getCurrentLanguageUmbraco() {
        // Replace this with your logic to retrieve the current language
        // For example, you can retrieve it from localStorage or from a state variable
        const lang = localStorage.getItem("eahsLang") ?? "en";
        if (lang == "en") return 'en-US';
        else return 'ar-AE'; // Defaulting to English for demonstration
    }


    useEffect(() => {
        async function getdata() {
            const umbraco = await axios.get(`/umbraco/delivery/api/v2/content?fetch=children:${fetch}&skip=0&take=10`)
            const formattedData = umbraco.data?.items.map((item) => ({
                name: item.properties?.title,
                image: item.properties?.image ? item.properties?.image[0]?.url : '',
                link: item?.properties?.link ?? '',
                title: item?.properties?.title ?? "",
                subTitle: item?.properties?.subTitle ?? "",
            }));
            setTotal(umbraco.data?.total)
            setSponsers([...formattedData]);
        }
        getdata();

    }, [currentLanguage])

    const carouselOptions = {
        loop: false,
        margin: 10,
        nav: false,
        dotsEach: 1,
        autoplay: true,
        startPosition: getCurrentLanguageUmbraco() == 'ar-AE' ? sponsers.length - 1 : 0,
        autoplayTimeout: 1500,
        autoplayHoverPause: true,
        dir: "ltr",
        reversed: currentLanguage == 'ar',
        dots: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2,
            },
            1000: {
                center: sponsers.length <= 1 ? true : false,
                items: isPartner ? 3 : 5,
            },
        },
    };


    return (
        <>
            {total > 0 &&
                <>
                    <div className="container sponser_bg">
                        <div className="seasonSectionTitle mediaGalleryTitle">
                            <span className="roboto-light">{translate(title, 'Partners')}</span>
                        </div>
                        <div className="row">
                            {isHomePage &&
                                <ReactOwlCarousel className="owl-theme"  {...carouselOptions} marginWidth={1}>
                                    {sponsers.map((item, index) => (
                                        <div className="col-sm-12 text-center">
                                            {item.link != '' ?
                                                <a href={item.link} target={item.link != '' ? "_blank" : ''}>
                                                    {!!(item.image) &&

                                                        <img
                                                            src={`${MediaBaseURL}${item.image}`}
                                                            className="sponser_img"
                                                            alt="sponser"
                                                        />
                                                    }
                                                    <div className="newsPostTitle roboto-bold">{item.name}</div>
                                                    <div className="newsPostDesc roboto-regular">{item.subTitle}</div>
                                                </a> :
                                                <div>
                                                    {!!(item.image) &&
                                                        <img
                                                            src={`${MediaBaseURL}${item.image}`}
                                                            className="sponser_img"
                                                            alt="sponser"
                                                        />
                                                    }
                                                    <div className="newsPostTitle roboto-bold">{item.name}</div>
                                                    <div className="newsPostDesc roboto-regular">{item.subTitle}</div>
                                                </div>}
                                        </div>
                                    ))}
                                </ReactOwlCarousel>
                            }
                            {!isHomePage &&
                                <div className="justRotate justify-content-center row">
                                    {sponsers.map((item, index) => (
                                        <div className={isPartner?"col-lg-3 col-md-3 col-sm-4 col-4 text-center":"col-lg-2 col-md-3 col-sm-4 col-4 text-center"}>
                                            {item.link != '' ?
                                                <a href={item.link} target={item.link != '' ? "_blank" : ''}>
                                                    {!!(item.image) &&

                                                        <img
                                                            src={`${MediaBaseURL}${item.image}`}
                                                            className="w-100"
                                                            alt="sponser"
                                                        />
                                                    }
                                                    <div className="sponser_title">{item.name}</div>
                                                </a> :
                                                <div>
                                                    {!!(item.image) &&
                                                        <img
                                                            src={`${MediaBaseURL}${item.image}`}
                                                            className="w-100"
                                                            alt="sponser"
                                                        />
                                                    }
                                                    <div className="sponser_title">{item.name}</div>
                                                </div>
                                            }
                                        </div>
                                    ))}
                                </div>
                            }
                        </div>
                    </div>
                </>
            }
        </>
    );
}
